import {Component, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {AdminService} from "../../../services/admin.service";
import {Demokratiewerkstatt, DemokratiewerkstattCategory} from "../../../models/demokratiewerkstatt.model";
import {DemokratiewerkstattService} from "../../../services/demokratiewerkstatt.service";
import {DemokratiewerkstattCategoryService} from "../../../services/demokratiewerkstatt-category.service";

@Component({
  selector: 'app-demokratiewerkstatt-details',
  templateUrl: './demokratiewerkstatt-details.component.html',
  styleUrls: ['./demokratiewerkstatt-details.component.css']
})
export class DemokratiewerkstattDetailsComponent implements OnInit {
  public demokratiewerkstatt: Demokratiewerkstatt;
  public categorySubscription$: Subscription;
  public categories: DemokratiewerkstattCategory[] = [];
  public image: string =
    'https://res.cloudinary.com/dyekwrvwe/image/upload/v1709258959/placeholder_b3miif.jpg';

  public showSpinner: boolean = true;

  constructor(
    private readonly _demokratiewerkstattService: DemokratiewerkstattService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly adminService: AdminService,
    private readonly categoryService: DemokratiewerkstattCategoryService
  ) {
  }

  ngOnInit(): void {
    this.categoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription$ =
      this.categoryService.DemokratiewerkstattCategorySubject.subscribe(
        (response: DemokratiewerkstattCategory[]) => {
          this.categories = response;
        },
        (error) => {
          console.log('An error occured: ' + error);
        }
      );

    const id = +this.route.snapshot.params['id'];
    this._demokratiewerkstattService.getDemokratiewerkstatt(id).subscribe((response) => {
      let category_name = this.categories.find(
        (cat: any) => cat.id.toString() === response.category_id?.toString()
      );
      this.demokratiewerkstatt = response;
      this.showSpinner = false;
      this.demokratiewerkstatt.sponsor_images_url = this.convertStringToArray(
        this.demokratiewerkstatt.sponsor_images_url
      );

      this.demokratiewerkstatt.partners_images_url = this.convertStringToArray(
        this.demokratiewerkstatt.partners_images_url
      );
    });
  }

  public isAdmin() {
    return this.adminService.isLoggedIn();
  }

  public editProject() {
    this.router.navigateByUrl(`/demokratiewerkstatt/${this.demokratiewerkstatt.id}/edit`);
  }

  public deleteProject(demokratiewerkstatt: Demokratiewerkstatt) {
    this._demokratiewerkstattService.deleteProject(demokratiewerkstatt.id ?? 0).subscribe((response) => {
      this._demokratiewerkstattService.emitDemokratiewerkstattSubject();
      this.router.navigate(['/demokratiewerkstatt/list']);
    });
  }

  convertStringToArray(inputString: any) {
    const trimmedString = inputString.trim();
    if (trimmedString.startsWith('[') && trimmedString.endsWith(']')) {
      const stringWithoutBrackets = trimmedString.slice(1, -1);
      const stringArray = stringWithoutBrackets.split(',');
      const resultArray = stringArray.map(
        (element: any) => `${element.trim().slice(1, -1)}`
      );
      return resultArray;
    } else {
      return [];
    }
  }
}
